// avstemming-payroll-messages-part2 translations (English catalog).
window.PlummeI18n.register('en', {
  'ave.sec.src.complete': 'Complete',
  'ave.sec.src.notRelevant': 'Not relevant',
  'ave.sec.row.notCompared': 'Not compared',
  'ave.sec.run.done': 'Completed and reconciled',
  'ave.sec.run.draft': 'Draft — not posted',
  'ave.sec.run.ameldingMissing': 'A-melding missing',
  'ave.sec.run.notPaid': 'Not paid out',
  'ave.sec.run.paidAfter': 'Paid out after the period date',
  'ave.sec.sourcesTitle': 'Data sources',
  'ave.sec.thSource': 'Source',
  'ave.sec.thDetails': 'Details',
  'ave.sec.sourcesNote': 'A-melding and bank payment are currently registered outside Plumme. The reconciliation can confirm that a run has been reported and paid — not what Altinn or the bank responded.',
  'ave.sec.mainTitle': 'Automatic main reconciliation',
  'ave.sec.nothingToCompare': 'No figures to compare',
  'ave.sec.deviations': '{count} differences',
  'ave.sec.mainMatches': 'Payroll system and general ledger match overall',
  'ave.sec.thArea': 'Control area',
  'ave.sec.thPayrollSystem': 'Payroll system',
  'ave.sec.thLedger': 'General ledger',
  'ave.sec.mainNote': '{settled} of {comparable} comparable control areas match. Empty cells mean the source does not have the figure — not that the amount is zero.',
  'ave.sec.accountsTitle': 'Control accounts in the general ledger',
  'ave.sec.noAccounts': 'No accounts have been added to the payroll area in this period. Without control accounts there is no general ledger side to compare the payroll system with.',
  'ave.sec.thControlAccount': 'Control account',
  'ave.sec.thOpening': 'Opening balance',
  'ave.sec.thMovements': 'Movements in the period',
  'ave.sec.thClosing': 'Closing posted balance',
  'ave.sec.thBasis': 'Calculated basis',
  'ave.sec.accountsNote': 'Liability accounts carry a credit balance in the general ledger. The comparison is therefore made on the size of the movement — the sign follows the chart of accounts and is not an error.',
  'ave.sec.quick.needs': 'Needs assessment',
  'ave.sec.quick.all': 'All',
  'ave.sec.quick.change': 'Abnormal salary change',
  'ave.sec.quick.negNet': 'Negative net',
  'ave.sec.quick.noAmelding': 'Missing in A-melding',
  'ave.sec.quick.noTaxCard': 'Missing tax card',
  'ave.sec.quick.dup': 'Possible duplicate',
  'ave.sec.quick.leaver': 'Former employee',
  'ave.sec.quick.benefits': 'Benefits in kind',
  'ave.sec.quick.notPaid': 'Not paid out',
  'ave.sec.quick.done': 'Assessed',
  'ave.sec.card.sysVsLedger': 'Payroll system against general ledger',
  'ave.sec.card.sysVsLedgerHint': 'The control areas where the payroll system and the general ledger do not give the same figure.',
  'ave.sec.card.noAmeldingRuns': 'Runs without A-melding',
  'ave.sec.card.noAmeldingRunsHint': 'Posted payroll runs that are not registered as reported.',
  'ave.sec.card.netUnpaid': 'Net salary not paid out',
  'ave.sec.card.netUnpaidHint': 'Posted runs without a registered payout.',
  'ave.sec.card.dupes': 'Possible duplicate payments',
  'ave.sec.card.dupesHint': 'The same employee with the same gross amount in several runs in the period.',
  'ave.sec.card.changes': 'Abnormal salary changes',
  'ave.sec.card.changesHint': 'Employees with more than 30% deviation from earlier runs in the year.',
  'ave.sec.card.holidayDiff': 'Holiday pay difference',
  'ave.sec.card.holidayDiffHint': 'Calculated holiday pay liability against posted.',
  'ave.sec.card.negNet': 'Negative net amounts',
  'ave.sec.card.negNetHint': 'Payroll lines where the deductions exceed the payout.',
  'ave.sec.card.noTaxCard': 'Employees without a valid tax card',
  'ave.sec.card.noTaxCardHint': 'The tax card has not been retrieved, or it had expired on the payment date.',
  'ave.sec.card.linesNoAmelding': 'Payroll lines without A-melding',
  'ave.sec.card.linesNoAmeldingHint': 'Lines in runs that are not registered as reported.',
  'ave.sec.card.leaver': 'Payment to former employee',
  'ave.sec.card.leaverHint': 'Salary paid out after the registered end date.',
  'ave.sec.card.benefits': 'Benefits in kind to review',
  'ave.sec.card.benefitsHint': 'Payroll lines with taxable benefits in kind.',
  'ave.sec.card.accountDev': 'Control accounts with deviations',
  'ave.sec.card.accountDevHint': 'Control accounts where the posted movement does not match the basis.',
  'ave.sec.card.lines': 'Payroll lines in the period',
  'ave.sec.card.linesHint': 'All lines in the posted runs.',
  'ave.sec.card.openTerms': 'Open tax and contribution terms',
  'ave.sec.card.openTermsHint': 'Terms with tax withholding or employer contributions that are not settled.',
  'ave.sec.card.checksRun': 'Automatic checks run: {count}',
  'ave.sec.card.checksWithFindings': 'Checks with findings: {count}',
  'ave.sec.card.flaggedLines': 'Payroll lines with alerts: {count}',
  'ave.sec.card.title': 'Control card',
  'ave.sec.card.hide': 'Hide',
  'ave.sec.card.showAll': 'Show all automatic checks',
  'ave.sec.noRuns': 'No payroll runs belong to this period. Without runs there is no payroll to reconcile.',
  'ave.sec.thPayDate': 'Pay date',
  'ave.sec.thPosted': 'Posted',
  'ave.sec.voucher': 'Voucher {number}',
  'ave.sec.reported': 'Reported',
  'ave.sec.afterPeriod': 'After period',
  'ave.sec.runsNote': 'The figures are the runs\' own. The reconciliation compares them with the general ledger — it does not recalculate payroll.',
  'ave.det.am.noRuns': 'No runs to report',
  'ave.det.am.allReported': 'All runs registered as reported',
  'ave.det.am.runsMissing': '{count} runs missing',
  'ave.det.am.runsReported': 'Runs reported',
  'ave.det.am.lastSubmitted': 'Last registered as submitted',
  'ave.det.am.recipients': 'Income recipients in the period',
  'ave.det.am.grossPerSystem': 'Gross salary per the payroll system',
  'ave.det.agaBase': 'Employer contribution basis',
  'ave.det.agaComputed': 'Calculated employer contribution',
  'ave.det.am.runsWithout': 'Runs without a registered A-melding',
  'ave.det.am.notReported': 'Not reported',
  'ave.det.am.runLine': '{count} employees · {money} gross · pay date {date}',
  'ave.det.am.openTheRun': 'Open the run',
  'ave.det.am.info': 'The A-melding is submitted in Altinn and registered manually in Plumme. The reconciliation can therefore confirm that a run has been reported — not which figures Altinn received or what the feedback said. Check the feedback in Altinn before the area is sent for review.',
  'ave.det.bank.noRuns': 'No runs to pay',
  'ave.det.bank.allPaid': 'All net salary is registered as paid out',
  'ave.det.bank.unpaid': '{money} not paid out',
  'ave.det.bank.expectedNet': 'Expected net salary',
  'ave.det.bank.registeredPaid': 'Registered as paid out',
  'ave.det.bank.thExpected': 'Expected amount',
  'ave.det.bank.thPaid': 'Paid out',
  'ave.det.bank.thPayDate': 'Payment date',
  'ave.det.bank.note': 'Paid out after {date} is not an error — it is a timing difference. It must still be assessed, because the liability remains on the balance sheet at the end of the period.',
  'ave.det.tax.withholdingPeriod': 'Tax withholding in the period',
  'ave.det.tax.openTerms': 'Open terms',
  'ave.det.tax.openAmount': 'Open amount',
  'ave.det.tax.thTerm': 'Term',
  'ave.det.tax.thDue': 'Due date',
  'ave.det.tax.thAga': 'Employer contribution',
  'ave.det.tax.paid': 'Paid',
  'ave.det.tax.thOpen': 'Open',
  'ave.det.tax.partlyPaid': 'Partly paid',
  'ave.det.tax.notPaid': 'Not paid',
  'ave.det.tax.noTerms': 'No tax or contribution terms affect this period.',
  'ave.det.hol.noAccountBadge': 'No holiday pay account in the area',
  'ave.det.hol.matches': 'The holiday pay liability matches',
  'ave.det.hol.inDiff': '{money} difference',
  'ave.det.hol.opening': 'Opening holiday pay liability',
  'ave.det.hol.earned': 'Earned in the period',
  'ave.det.hol.paidOut': 'Holiday pay paid out',
  'ave.det.hol.closingComputed': 'Closing calculated liability',
  'ave.det.hol.booked': 'Posted holiday pay liability',
  'ave.det.hol.noAccount': 'No holiday pay account has been added to the payroll area. Without the account there is no posted liability to compare the calculated one with.',
  'ave.det.hol.agaOnHoliday': 'Employer contribution on holiday pay',
  'ave.det.hol.basis': 'Basis',
  'ave.det.hol.rate': 'Rate',
  'ave.det.hol.computedFee': 'Calculated contribution',
  'ave.det.hol.postedShort': 'Posted',
  'ave.det.hol.pensionTitle': 'Pension and other deductions',
  'ave.det.hol.pensionPremium': 'Pension premium per the payroll system',
  'ave.det.hol.pensionBooked': 'Posted pension',
  'ave.det.hol.holidayBase': 'Holiday pay basis',
  'ave.det.hol.noPensionAccount': 'The payroll system calculates a pension premium, but no pension account has been added to the payroll area. Without the account the premium cannot be reconciled against the general ledger.',
  'ave.det.hol.requestPension': 'Ask the client for the pension basis',
  'ave.det.doc.thDocument': 'Document',
  'ave.det.doc.thType': 'Type',
  'ave.det.doc.thAdded': 'Added',
  'ave.det.doc.fromClient': 'From the client',
  'ave.det.doc.addedByFirm': 'Added by the firm',
  'ave.det.doc.none': 'No documents are linked to the payroll area in this period.',
  'ave.det.doc.note': 'The payroll journal, posting vouchers and payment basis are on the payroll runs themselves and are not documents anyone needs to upload. What belongs here is basis that comes from outside — pension invoices, feedback from Altinn and agreements.',
  'ave.drw.as.notAssessed': 'Not assessed',
  'ave.drw.as.noCorrection': 'No correction needed',
  'ave.drw.as.realDeviation': 'Real deviation — confirmed',
  'ave.drw.as.payrollError': 'Error in the payroll system — to be corrected',
  'ave.drw.as.postingError': 'Incorrect posting — to be corrected',
  'ave.drw.as.ameldingError': 'Error in A-melding — requires correction',
  'ave.drw.as.paymentError': 'Incorrect payment',
  'ave.drw.as.timing': 'Timing difference against bank',
  'ave.drw.as.awaitDocs': 'Awaiting documentation',
  'ave.drw.as.awaitClient': 'Awaiting the client',
  'ave.drw.as.nextPeriod': 'Follow up next period',
  'ave.drw.subtitle': '{run} · {type} · pay date {date}',
  'ave.drw.benefits': 'Benefits in kind',
  'ave.drw.holidayAccrued': 'Holiday pay earned',
  'ave.drw.changeFromPrev': 'Change from previous',
  'ave.drw.noHistory': 'No history',
  'ave.drw.reason': 'Justification',
  'ave.drw.reasonRequired': 'Justification (required)',
  'ave.drw.reasonPlaceholder': 'What does the review of this payroll line show?',
  'ave.drw.measure': 'Action',
  'ave.drw.measurePlaceholder': 'E.g. Correct the A-melding or reverse the payment',
  'ave.drw.deadline': 'Follow-up deadline',
  'ave.drw.followUpNote': 'The payroll line will appear as a follow-up suggestion under “Conclusion and approval”.',
  'ave.drw.needsReason': 'This assessment requires a justification.',
  'ave.drw.save': 'Save assessment',
});
